<template>
  <div class="toast-fo-list">
    <div>{{ message }}</div>
    <b-button class="toast-fo-list__btn" v-on="$listeners">
      {{ buttonText }}
    </b-button>
  </div>
</template>

<script>
import i18n from '@/i18n'

export default {
  computed: {
    message() {
      return i18n.t('routeOptimization.alert.assignmentSuccess') || 'Penugasan berhasil dibuat'
    },
    buttonText() {
      return i18n.t('routeOptimization.action.viewAssignmentList') || 'Lihat daftar penugasan'
    },
  },
}
</script>

<style lang="scss" scoped>
.toast-fo-list {
  display: flex;
  justify-content: space-between;
  gap: 80px;

  &__btn {
    padding: 0;
    border-color: transparent;
    background-color: transparent;
    font-size: 11px;

    &:hover {
      border-color: transparent;
      background-color: transparent;
    }
  }
}
</style>
